const pageListResources = {
  en: {
    pageList: {
      'О нас': 'About us',
      Акционеры: 'Shareholders',
      Лицензии: 'Licenses',
      'Финансовые показатели': 'Financial indicators',
      Регистрация: 'Certificate of re-registration',
      'Рекомендательные письма': 'Recommendation letters',
      'Политика конфиденциальности': 'Privacy policy',
      Руководство: 'Administration',
      'Совет директоров': 'Board of Directors',
      Партнеры: 'Partners',
      'Реестр страховых агентов': 'Register of Insurance Agents',
      'Размеры комиссионных':
        'The amount of commission fees of insurance agents',
      Реквизиты: 'Requisites',
      ESG: 'ESG',
      'Корпоративное управление': 'Corporate governance',
      Группа: 'Group',
      Вакансии: 'Vacancies',
      Контакты: 'Contacts',
      'Правила страхования': 'Insurance rules',
      selectButton: 'Select section',
      company: 'Company',
      online: 'Insurance online',
      useful: 'Useful',
      documentations: 'Documentation',
    },
  },
  kz: {
    pageList: {
      'О нас': 'Біз туралы',
      Акционеры: 'Акционерлер',
      Лицензии: 'Лицензиялар',
      'Финансовые показатели': 'Қаржылық көрсеткіштер',
      Регистрация: 'Қайта тіркеу туралы анықтама',
      'Рекомендательные письма': 'Ұсыну хаттар',
      'Политика конфиденциальности': 'Құпиялылық саясаты',
      Руководство: 'Басшылық',
      'Совет директоров': 'Директорлар Кеңесі',
      Партнеры: 'Серіктестер',
      'Реестр страховых агентов': 'Сақтандыру агенттерінің тізілімі',
      'Размеры комиссионных':
        'Сақтандыру агенттерінің комиссиялық сыйақы мөлшері',
      Реквизиты: 'Деректемелері',
      ESG: 'ESG',
      'Корпоративное управление': 'Корпоративтік басқару',
      Группа: 'Топ',
      Вакансии: 'Вакансиялар',
      Контакты: 'Байланыс',
      'Правила страхования': 'Сақтандыру қағидалары',
      selectButton: 'Бөлімді таңдау',
      company: 'Компания',
      online: 'Сақтандыру онлайн',
      useful: 'Пайдалы',
      documentations: 'Құжаттама',
    },
  },
  ru: {
    pageList: {
      'О нас': 'О нас',
      Акционеры: 'Акционеры',
      Лицензии: 'Лицензии',
      'Финансовые показатели': 'Финансовые показатели',
      Регистрация: 'Справка о перерегистрации',
      'Рекомендательные письма': 'Рекомендательные письма',
      'Политика конфиденциальности': 'Политика конфиденциальности',
      Руководство: 'Руководство',
      'Совет директоров': 'Совет директоров',
      Партнеры: 'Партнеры',
      'Реестр страховых агентов': 'Реестр страховых агентов',
      'Размеры комиссионных': 'Размеры комиссионных',
      Реквизиты: 'Реквизиты',
      ESG: 'ESG',
      'Корпоративное управление': 'Корпоративное управление',
      Группа: 'Группа',
      Вакансии: 'Вакансии',
      Контакты: 'Контакты',
      'Правила страхования': 'Правила страхования',
      selectButton: 'Выбрать раздел',
      company: 'Компания',
      online: 'Страхование онлайн',
      useful: 'Полезно',
      documentations: 'Документация',
    },
  },
};

export default pageListResources;
